(function (app, ng) {

    app.controller("addAppointmentController", addAppointmentController);

    function addAppointmentController($q, $state, $mdDialog, _preferredCommunications, appointmentApi, clientApi, userApi) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.preferredCommunications = _preferredCommunications;
            $ctrl.attendees = [];
            $ctrl.assignedUsers = [$ctrl.currentUser];
            $ctrl.selectedStartDate = new Date();

            $ctrl.ui = {
                loading: false,
            }

            $ctrl.appointment = {
                StartDate: $ctrl.selectedStartDate,
                EndDate: $ctrl.selectedStartDate,
            }

            if ($ctrl.client) {
                $ctrl.appointment.MainAttendee = $ctrl.client;
            }
        };

        const close = () => {
            $mdDialog.hide();
        }

        const createAppointment = (appointment, attendees, assignedUsers) => {
            $ctrl.ui.loading = true;

            appointment.AssignedUsers = assignedUsers;

            appointmentApi.createAppointment(appointment).then(response => {
                const promises = [
                    ...attendees.map(attendee => appointmentApi.addAttendee(response.Id, attendee.Id)),
                ];

                $q.all(promises).then(() => {
                    $state.go("Home.Appointment", { appointmentId: response.Id }, {});

                    $ctrl.close();
                });
            });
        }

        const addAttendee = (client) => {
            if (!!client) {
                $ctrl.attendees.push(client);
            }
        }

        const removeAttendee = (clientId) => {
            const attendeeIndex = $ctrl.attendees(attendee => attendee.Id === clientId);

            $ctrl.attendees.splice(attendeeIndex, 1);
        }

        const addAssignedUser = (user) => {
            if (!!user) {
                $ctrl.assignedUsers.push(user);
            }
        }

        const removeAssignedUser = (userId) => {
            const assignedUserIndex = $ctrl.assignedUsers(assignedUser => assignedUser.Id === userId);

            $ctrl.assignedUsers.splice(assignedUserIndex, 1);
        }

        const buildPreferredCommunicationStr = (client, preferredCommunication) => {
            let prefCommStr = $ctrl.preferredCommunications.find(communication => {
                return communication.ShortName === preferredCommunication;
            });

            const startsWithEmail = preferredCommunication.startsWith("Email");

            if (startsWithEmail && client.Person.PrimaryEmailAddress) {
                prefCommStr = `${prefCommStr}: ${client.Person.PrimaryEmailAddress.Value}`;
            }
            else if (!startsWithEmail && client.Person.PrimaryPhoneNumber) {
                const phoneNumber = client.Person.PrimaryPhoneNumber.Value.replace(/(\d{3})(\d{3})(\d+)/, "$1-$2-$3");

                prefCommStr = `${prefCommStr}: ${phoneNumber}`;
            }

            return prefCommStr;
        }

        const formatAttendeeDisplay = (client) => {
            let result = `${client.Person.FirstName} ${client.Person.LastName}`;

            if (!!client.Person.PreferredCommunication) {
                const preferredCommunication = buildPreferredCommunicationStr(client.Person);

                result = `${result} (${preferredCommunication})`;
            }

            return result;
        }

        const searchClients = (term) => {
            return clientApi.searchClients(term).then(clients => {
                return clients.filter(client => {
                    const isMainAttendee = !!$ctrl.appointment.MainAttendee &&
                        $ctrl.appointment.MainAttendee.Id === client.Id;

                    const isAdditionalAttendee = $ctrl.attendees.some(attendee => attendee.Id === client.Id);

                    return !isMainAttendee && !isAdditionalAttendee;
                });
            });
        }

        const searchUsers = (term) => {
            return userApi.searchUsers(term).then(users => {
                return users.filter(user => !$ctrl.assignedUsers.some(assignedUser => assignedUser.Id === user.Id));
            });
        }

        const updateDates = (startTime, endTime) => {
            /*
            const startDate = new Date(date);

            const endDate = new Date(date);

            if (!!startTime && !endTime) {
                startDate.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0);

                endDate.setHours(startDate.getHours() + 1, startDate.getMinutes(), 0, 0);
            }
            else if (!startTime && !!endTime) {
                endDate.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);

                startDate.setHours(endDate.getHours() - 1, endDate.getMinutes(), 0, 0);
            }
            else if (!!startTime && !!endTime) {
                startDate.setHours(startTime.getHours(), startTime.getMinutes(), 0, 0);

                endDate.setHours(endTime.getHours(), endTime.getMinutes(), 0, 0);
            }
            */
            $ctrl.appointment.StartDate = startTime;

            $ctrl.appointment.EndDate = endTime;

            // TODO: need this to update the UI. Find a better way.
            $ctrl.selectedStartTime = startTime;

            $ctrl.selectedEndTime = endTime;
        }

        const updateStartDate = (date, time) => {
            const startDate = new Date(date);
            startDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
            $ctrl.appointment.StartDate = startDate;
        };

        const updateEndDate = (date, time) => {
            const endDate = new Date(date);
            endDate.setHours(time.getHours(), time.getMinutes(), 0, 0);
            $ctrl.appointment.EndDate = endDate;
        };

        ng.extend($ctrl,
            {
                close,
                createAppointment,
                addAttendee,
                removeAttendee,
                addAssignedUser,
                removeAssignedUser,
                formatAttendeeDisplay,
                searchClients,
                searchUsers,
                updateDates,
                updateStartDate,
                updateEndDate
            });
    }

})(window.app, window.angular); // jshint ignore:line